import {
  AutomationActionAtlassianCreateTaskDenormalized,
  IAutomationActionTemplateAtlassianCreateIssue
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import {
  escapeReplacements,
  LightMdToJsx
} from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryAtlassianCreateTask = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateAtlassianCreateIssue
    | AutomationActionAtlassianCreateTaskDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t(
            'Create an issue in the project **{{ project }}** with the summary **{{ summary }}**.',
            {
              project: a.project.name || '...',
              summary: escapeReplacements(a.summary || '...')
            }
          )}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
